import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
class EdAddMenu extends Vue {
  
  @Prop() readonly options: any[];
  @Prop() readonly isButton: boolean;
  @Prop() readonly textButton: string;
  @Prop() readonly orientation: string;
  @Prop() readonly disabled: boolean;
  @Prop() readonly tooltip: string;


  get label() {
    return this.textButton ? this.textButton : '';
  }

  get arrowOrientation() {
    return this.orientation ? `arrow--${this.orientation}` : '';
  }

  get addMenuClass() {
    return {
      'ed-add-menu--disabled': this.disabled
    }
  }

  buttonAction() {
    if(!this.disabled) {
      this.$emit('clicked');
    }
  }

  selectOption(optionSelected) {
    this.$emit('selectOption', optionSelected);
  }

}

export default Vue.component('ed-add-menu', EdAddMenu);